<template>
  <el-dialog title="二级审核评价"
             :visible.sync="dialogVisible"
             width="50%"
             top="20px"
             :close-on-click-modal="false"
             destroy-on-close
             @closed="progressAfterDialogClosed">
    <div class="evaluation-header">
      <span class="evaluation-title">综合得分</span>
      <span class="evaluation-score">{{ avgScore }}</span>
      <span class="evaluation-total">(5分)</span>
    </div>

    <el-form label-width="180px"
             :model="form"
             :rules="rules"
             label-position="top"
             ref="formRef">
      <el-form-item label="项目推进的及时性得分"
                    prop="timeliness_score">
        <el-rate v-model="form.timeliness_score"
                 :max="5"
                 show-score
                 score-template="{value}分">
        </el-rate>
      </el-form-item>

      <el-form-item label="项目报告的准确性得分"
                    prop="report_accuracy_score">
        <el-rate v-model="form.report_accuracy_score"
                 :max="5"
                 show-score
                 score-template="{value}分">
        </el-rate>
      </el-form-item>

      <el-form-item label="项目客户的满意度得分"
                    prop="customer_satisfaction_score">
        <el-rate v-model="form.customer_satisfaction_score"
                 :max="5"
                 show-score
                 score-template="{value}分">
        </el-rate>
      </el-form-item>

      <el-form-item label="评价内容"
                    prop="evaluation_content">
        <el-input v-model="form.evaluation_content"
                  type="textarea"
                  :rows="6"
                  placeholder="请输入评价内容"
                  maxlength="500"
                  show-word-limit>
        </el-input>
      </el-form-item>
    </el-form>

    <div slot="footer"
         class="dialog-footer">
      <el-button type="primary"
                 @click="onSubmit">提交评价
      </el-button>
      <el-button @click="dialogVisible = false">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import userWorkInfoMixin from '@views/user-workinfo/user-workinfo.mixin.js'
import projectMixins from '@views/project/project.mixins'

export default {
  mixins: [userWorkInfoMixin, projectMixins],
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    projectId: {
      type: String,
      default: '0',
    },
    fullNode: {
      type: Object,
      default: () => ({}),
    },
  },
  data () {
    return {
      form: {
        timeliness_score: 0,
        report_accuracy_score: 0,
        customer_satisfaction_score: 0,
        evaluation_content: '',
      },
      rules: {
        timeliness_score: [
          { required: true, message: '请评分', trigger: 'change', type: 'number', min: 1 }
        ],
        report_accuracy_score: [
          { required: true, message: '请评分', trigger: 'change', type: 'number', min: 1 }
        ],
        customer_satisfaction_score: [
          { required: true, message: '请评分', trigger: 'change', type: 'number', min: 1 }
        ],
        evaluation_content: [
          { required: true, message: '请输入评价内容', trigger: 'blur' },
          { min: 1, max: 500, message: '长度在 1 到 500 个字符', trigger: 'blur' }
        ],
      },
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.visible
      },
      set (val) {
        this.$emit('update:visible', val)
      },
    },
    avgScore () {
      const total = _.get(this.form, 'timeliness_score', 0) +
        _.get(this.form, 'report_accuracy_score', 0) +
        _.get(this.form, 'customer_satisfaction_score', 0)
      return (total / 3).toFixed(1)
    },
  },
  watch: {
    visible: {
      handler (val) {
        if (val) {
          this.initAttr(this.fullNode.project_node || {})
        }
      },
      immediate: true,
    },
  },
  methods: {
    initAttr (projectNode) {
      const evaluation = _.get(projectNode, 'node_result', {})
      this.form = {
        timeliness_score: evaluation.timeliness_score || 0,
        report_accuracy_score: evaluation.report_accuracy_score || 0,
        customer_satisfaction_score: evaluation.customer_satisfaction_score || 0,
        evaluation_content: evaluation.evaluation_content || '',
      }
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.clearValidate()
      })
    },
    async onSubmit () {
      try {
        await this.$refs.formRef.validate()
      } catch (e) {
        return
      }

      const params = {
        id: this.projectId,
        ...this.form
      }
      try {
        await this.withLoading(async () => {
          const res = await request.common('saveSecondScoreApi', params)
          this.progressDialogAfterSubmitSuccess(res.data)
          this.$message.success('评价提交成功')
        })
      } catch (error) {
        this.$message.error(error.message || '提交失败')
      }
    },
  },
}
</script>

<style lang="scss"
       scoped>
.evaluation-header {
  display: flex;
  align-items: baseline;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #ebeef5;

  .evaluation-title {
    font-size: 18px;
    font-weight: 600;
    color: #303133;
    margin-right: 12px;
  }

  .evaluation-score {
    font-size: 24px;
    font-weight: 700;
    color: #ef104b;
    margin-right: 4px;
  }

  .evaluation-total {
    font-size: 14px;
    color: #909399;
  }
}

.dialog-footer {
  display: flex;
  justify-content: flex-start;
  gap: 20px;

  .el-button {
    min-width: 100px;
  }

  .el-button--primary {
    background-color: #409eff;
    border-color: #409eff;
  }
}

/deep/ .el-form-item {
  margin-bottom: 12px;
}
/deep/ .el-form-item__label {
  padding-bottom: 4px;
  line-height: 1.4;
}

/* 增大评分星星 */
/deep/ .el-rate__icon {
  font-size: 24px;
}
/deep/ .el-rate__text {
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/views/project/components/SecondEvaluationDialog.vue